import type { KeyboardEvent, RefObject } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router';

import type { NavigationItem } from '@/data/navigation';
import { Button } from '@/components/ui/button';

type MobileNavigationProps = {
  items: readonly NavigationItem[];
  isOpen: boolean;
  menuButtonRef: RefObject<HTMLDivElement>;
  mobileMenuRef: RefObject<HTMLElement>;
  onToggle: () => void;
  onClose: () => void;
  onMenuButtonKeyDown: (event: KeyboardEvent<HTMLButtonElement>) => void;
  onMenuKeyDown: (event: KeyboardEvent<HTMLElement>) => void;
};

const MobileNavigation = ({
  items,
  isOpen,
  menuButtonRef,
  mobileMenuRef,
  onToggle,
  onClose,
  onMenuButtonKeyDown,
  onMenuKeyDown,
}: MobileNavigationProps) => (
  <>
    <div ref={menuButtonRef} className="absolute top-14 right-4 z-10 md:hidden">
      <Button
        variant="ghost"
        className="h-12 w-12 rounded-lg border border-primary/20 bg-background p-0 text-primary shadow-sm hover:bg-primary/10 hover:text-primary active:scale-[0.97] [&_svg]:size-7"
        onClick={onToggle}
        onKeyDown={onMenuButtonKeyDown}
        aria-label={isOpen ? 'メニューを閉じる' : 'メニューを開く'}
        aria-expanded={isOpen}
        aria-controls="mobile-menu"
      >
        {isOpen ? <X /> : <Menu />}
      </Button>
    </div>

    {isOpen && (
      <nav
        id="mobile-menu"
        ref={mobileMenuRef}
        className="border-t border-border bg-background text-center md:hidden"
        onKeyDown={onMenuKeyDown}
      >
        <ul className="flex flex-col gap-1 px-4 py-3">
          {items.map((item) => (
            <li key={item.label}>
              <Link
                to={item.href}
                className="block min-h-11 rounded-md px-4 py-3 font-medium text-primary underline-offset-4 transition-colors visited:text-primary hover:bg-primary/10 hover:text-primary hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                onClick={onClose}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    )}
  </>
);

export default MobileNavigation;
